import type React from 'react'

import type { EditBreadcrumbItem, ExtensionEditWrapperComponent } from './types'

export const renderWithWrapper = (
  wrapper: ExtensionEditWrapperComponent | undefined,
  breadcrumbs: EditBreadcrumbItem[],
  content: React.ReactNode,
) => {
  if (!wrapper) return content
  const Wrapper = wrapper
  return <Wrapper breadcrumbs={breadcrumbs}>{content}</Wrapper>
}
